import { Dialog, DialogPanel } from "@headlessui/react";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { resetPrivacyData } from "../../redux/slices/coursePrivacySlice";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import MaterialStatistic from "../classdetail/MaterialStatistic";
import MaterialQuestions from "../classdetail/MaterialQuestions";
import MaterialAbout from "../classdetail/MaterialAbout";

export default function MaterialDeckDetailModel({ data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const privacy = useSelector((state) => state.coursePrivacyData.data);
  const [activeTab, setActiveTab] = useState("Questions")

  return (
    <div>
      <Dialog
        open={privacy === "Nematoniekas"}
        as="div"
        className="relative z-30 focus:outline-none "
        onClose={() => {
          dispatch(resetPrivacyData(""));
        }}
      >
        <div className="fixed inset-0 z-10 w-screen  overflow-y-auto ">
          <div className="flex min-h-full items-center  justify-center p-4 bg-black/35 backdrop-blur-sm ">
            <DialogPanel
              transition
              className="w-full relative max-w-5xl rounded-3xl bg-white duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0  overflow-y-auto pt-14 md:pt-10"
            >
              <div className="p-6 -mt-14 bg-white relative z-10  rounded-3xl ">
                <div className="flex justify-between items-center">
                  <div>
                    <div className="flex justify-start items-center gap-3">
                      <div className="text-xl font-semibold">
                        {data?.deckName || "-"}
                        <div className="text-sm font-medium text-lightgray flex gap-2 items-center my-2">
                          <h6 className="text-center"> {data?.mainSubject || "*"}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <IoMdClose
                      className="absolute top-5 md:top-10 right-5 cursor-pointer"
                      fontSize={20}
                      onClick={() => {
                        dispatch(resetPrivacyData(""));
                      }}
                    />
                  </div>
                </div>

                <div className="h-14 border-b flex flex-wrap justify-between items-center text-xl font-semibold">
                  <ul className="flex  items-center gap-5 text-base xxs:text-sm h-full text-lightgray font-semibold">
                    <li
                      className={`${activeTab === "Questions" ? "border-b border-black text-black" : ""} h-full  flex items-center justify-center cursor-pointer`}
                      onClick={() => setActiveTab("Questions")}
                    >
                      {t("questions")} ({data?.cards?.length})
                    </li>
                    <li
                      className={`${activeTab === "About" ? "border-b border-black text-black" : ""} h-full  flex items-center justify-center cursor-pointer`}
                      onClick={() => setActiveTab("About")}
                    >
                      {t("about")}
                    </li>
                    <li
                      className={`${activeTab === "Statistics" ? "border-b border-black text-black" : ""} h-full  flex items-center justify-center cursor-pointer`}
                      onClick={() => setActiveTab("Statistics")}
                    >
                      {t("Statistics")}
                    </li>
                  </ul>
                </div>
                {activeTab === "Questions" && <MaterialQuestions data={data} />}
                {activeTab === "About" && <MaterialAbout data={data} />}
                {activeTab === "Statistics" && <MaterialStatistic data={data} />}
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
